import { FormType } from '../../../../form-types';
import { MetabolicTadalafilFieldAnswers } from '../questions';

const metabolicTadalafil: FormType<MetabolicTadalafilFieldAnswers> = {
  name: 'Tadalafil Consultation',
  questions: [
    {
      key: 'metabolicTadalafil_contraindications',
      next: {
        switch: [
          {
            condition: {
              'metabolicTadalafil_contraindications.mi_within_last_6_months':
                true
            },
            key: 'metabolicTadalafil_ineligible'
          },
          {
            condition: {
              'metabolicTadalafil_contraindications.hypertrophic_cardiomyopathy_or_uncontrolled_hf':
                true
            },
            key: 'metabolicTadalafil_ineligible'
          },
          {
            condition: {
              'metabolicTadalafil_contraindications.heart_arrhythmia_or_qt_prolongation':
                true
            },
            key: 'metabolicTadalafil_ineligible'
          },
          {
            condition: {
              'metabolicTadalafil_contraindications.stroke_or_brain_hemorrhage_within_last_12_months':
                true
            },
            key: 'metabolicTadalafil_ineligible'
          },
          {
            condition: {
              'metabolicTadalafil_contraindications.sickle_cell_anemia_or_myeloma_or_leukemia':
                true
            },
            key: 'metabolicTadalafil_ineligible'
          },
          {
            condition: {
              'metabolicTadalafil_contraindications.retinitis_pigmentosa_or_sudden_vision_loss':
                true
            },
            key: 'metabolicTadalafil_ineligible'
          },
          {
            condition: {
              'metabolicTadalafil_contraindications.pulmonary_hypertension':
                true
            },
            key: 'metabolicTadalafil_ineligible'
          },
          {
            condition: {
              'metabolicTadalafil_contraindications.penile_curve_or_painful_erections_or_tight_foreskin':
                true
            },
            key: 'metabolicTadalafil_ineligible'
          }
        ],
        els: 'metabolicTadalafil_cardiovascularSymptoms'
      }
    },
    {
      key: 'metabolicTadalafil_cardiovascularSymptoms',
      next: {
        condition: { 'metabolicTadalafil_cardiovascularSymptoms.none': true },
        key: 'metabolicTadalafil_illicitDrugUse',
        els: 'metabolicTadalafil_ineligible'
      }
    },
    {
      key: 'metabolicTadalafil_illicitDrugUse',
      next: {
        condition: { 'metabolicTadalafil_illicitDrugUse.other': true },
        key: 'metabolicTadalafil_illicitDrugOtherDetails',
        els: 'metabolicTadalafil_consent'
      }
    },
    'metabolicTadalafil_illicitDrugOtherDetails',
    {
      key: 'metabolicTadalafil_consent',
      next: {
        switch: [
          {
            condition: { 'metabolicTadalafil_consent.non_consent': true },
            key: 'metabolicTadalafil_didNotConsent'
          }
        ],
        els: 'metabolicTadalafil_complete'
      }
    },
    'metabolicTadalafil_complete',
    'metabolicTadalafil_ineligible',
    'metabolicTadalafil_didNotConsent'
  ]
};

export default metabolicTadalafil;
